import Header from "@/components/Header";
import Footer from "@/components/Footer";
import SEO from "@/components/SEO";

const Privacy = () => {
  return (
    <div className="min-h-screen bg-background">
      <SEO
        title="Privacybeleid | Bo Barbers Utrecht"
        description="Lees hoe Bo Barbers omgaat met persoonsgegevens, cookies en je rechten als klant volgens de AVG."
        path="/privacy"
      />
      <Header />
      
      {/* Hero Section */}
      <section className="pt-32 pb-16 bg-foreground">
        <div className="container mx-auto px-4 sm:px-6">
          <div className="max-w-4xl mx-auto text-center">
            <p className="text-white/60 uppercase tracking-[0.3em] mb-6 text-xs font-semibold">
              Juridisch
            </p>
            <h1 className="font-display text-4xl sm:text-5xl md:text-6xl font-bold text-white mb-6">
              Privacy Policy
            </h1>
            <div className="w-24 h-1 bg-white mx-auto"></div>
          </div>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-16 sm:py-24">
        <div className="container mx-auto px-4 sm:px-6">
          <div className="max-w-3xl mx-auto prose prose-lg">
            <div className="space-y-8 text-foreground/80">
              <div>
                <p className="text-sm text-muted-foreground mb-8">
                  Laatst bijgewerkt: December 2024
                </p>
              </div>

              <div>
                <h2 className="font-display text-2xl font-bold text-foreground mb-4">1. Inleiding</h2>
                <p className="leading-relaxed">
                  Bo Barbers, gevestigd aan de Twijnstraat 46 te Utrecht, is verantwoordelijk voor de verwerking van persoonsgegevens zoals weergegeven in deze privacyverklaring. Wij respecteren de privacy van onze klanten en bezoekers en gaan zorgvuldig om met uw persoonlijke gegevens.
                </p>
              </div>

              <div>
                <h2 className="font-display text-2xl font-bold text-foreground mb-4">2. Contactgegevens</h2>
                <p className="leading-relaxed">
                  Bo Barbers<br />
                  Twijnstraat 46<br />
                  3511 ZL Utrecht<br />
                  Telefoon: 030 720 0 888<br />
                  E-mail: info@bobarbers.nl
                </p>
              </div>

              <div>
                <h2 className="font-display text-2xl font-bold text-foreground mb-4">3. Persoonsgegevens die wij verwerken</h2>
                <p className="leading-relaxed mb-4">
                  Bo Barbers verwerkt uw persoonsgegevens doordat u gebruik maakt van onze diensten en/of omdat u deze zelf aan ons verstrekt. Hieronder vindt u een overzicht van de persoonsgegevens die wij verwerken:
                </p>
                <ul className="list-disc list-inside space-y-2">
                  <li>Voor- en achternaam</li>
                  <li>E-mailadres</li>
                  <li>Telefoonnummer</li>
                  <li>Adresgegevens (bij bestellingen)</li>
                  <li>Betalingsgegevens</li>
                  <li>Afspraakgeschiedenis</li>
                </ul>
              </div>

              <div>
                <h2 className="font-display text-2xl font-bold text-foreground mb-4">4. Doel van gegevensverwerking</h2>
                <p className="leading-relaxed mb-4">
                  Bo Barbers verwerkt uw persoonsgegevens voor de volgende doelen:
                </p>
                <ul className="list-disc list-inside space-y-2">
                  <li>Het afhandelen van uw betaling</li>
                  <li>Het verzenden van bestellingen</li>
                  <li>U te kunnen bellen of e-mailen indien nodig</li>
                  <li>Het maken en beheren van afspraken</li>
                  <li>Het verbeteren van onze dienstverlening</li>
                </ul>
              </div>

              <div>
                <h2 className="font-display text-2xl font-bold text-foreground mb-4">5. Bewaartermijn</h2>
                <p className="leading-relaxed">
                  Bo Barbers bewaart uw persoonsgegevens niet langer dan strikt nodig is om de doelen te realiseren waarvoor uw gegevens worden verzameld. Wij hanteren een bewaartermijn van maximaal 2 jaar voor klantgegevens na uw laatste bezoek of aankoop.
                </p>
              </div>

              <div>
                <h2 className="font-display text-2xl font-bold text-foreground mb-4">6. Delen met derden</h2>
                <p className="leading-relaxed">
                  Bo Barbers verstrekt uitsluitend aan derden en alleen als dit nodig is voor de uitvoering van onze overeenkomst met u of om te voldoen aan een wettelijke verplichting. Wij maken gebruik van diensten van derden voor betalingsverwerking (Stripe) en het beheren van afspraken.
                </p>
              </div>

              <div>
                <h2 className="font-display text-2xl font-bold text-foreground mb-4">7. Cookies</h2>
                <p className="leading-relaxed">
                  Bo Barbers gebruikt functionele en analytische cookies. Een cookie is een klein tekstbestand dat bij het eerste bezoek aan deze website wordt opgeslagen op uw computer, tablet of smartphone. De cookies die wij gebruiken zijn noodzakelijk voor de technische werking van de website en uw gebruiksgemak. U kunt zich afmelden voor cookies door uw internetbrowser zo in te stellen dat deze geen cookies meer opslaat.
                </p>
              </div>

              <div>
                <h2 className="font-display text-2xl font-bold text-foreground mb-4">8. Uw rechten</h2>
                <p className="leading-relaxed mb-4">
                  U heeft het recht om uw persoonsgegevens in te zien, te corrigeren of te verwijderen. Daarnaast heeft u het recht om uw eventuele toestemming voor de gegevensverwerking in te trekken of bezwaar te maken tegen de verwerking van uw persoonsgegevens door Bo Barbers.
                </p>
                <p className="leading-relaxed">
                  U kunt een verzoek tot inzage, correctie, verwijdering of gegevensoverdraging van uw persoonsgegevens sturen naar info@bobarbers.nl.
                </p>
              </div>

              <div>
                <h2 className="font-display text-2xl font-bold text-foreground mb-4">9. Beveiliging</h2>
                <p className="leading-relaxed">
                  Bo Barbers neemt de bescherming van uw gegevens serieus en neemt passende maatregelen om misbruik, verlies, onbevoegde toegang, ongewenste openbaarmaking en ongeoorloofde wijziging tegen te gaan. Als u de indruk heeft dat uw gegevens niet goed beveiligd zijn of er aanwijzingen zijn van misbruik, neem dan contact op via info@bobarbers.nl.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Privacy;
